import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CheckboxSpanish(_a) {
    var show = _a.show, text = _a.text, _b = _a.value, value = _b === void 0 ? false : _b, onChange = _a.onChange;
    if (!show)
        return null;
    return (_jsxs("label", { className: "form-check needs-spanish-lo", children: [_jsx("input", { className: "form-check-input", type: "checkbox", checked: value, onChange: function (e) { return onChange(e.target.checked); } }), _jsx("span", { className: "form-check-label", children: text || "Would you like to discuss your loan in Spanish?" })] }));
}
